import {
  Box,
  Img,
  Stack,
  VStack,
  Text,
  Grid,
  Center,
  useColorModeValue,
} from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import { v4 } from "uuid";
import { PROTECTED_PATHS } from "../../../app/constants";
import Container from "../../../components/Container";
import FullPageLoader from "../../../components/FullPageLoader";
import Header from "../../../components/Header";
import { AuthContext } from "../../../context/authContext";
import SearchBar from "./SearchBar";
import { useNavigate } from "react-router-dom";
import { getAdvertProducts } from "../service/topProducts";
import { COLORS } from "../../../constants/colors";
import { dynamicPathhandler } from "../../../components/utils/dynamicPathHandler";

const AllTopProduct = () => {
  const appTextColor = useColorModeValue(COLORS.black, COLORS.white);
  const { userInfo } = useContext(AuthContext);
  const { userId } = userInfo;
  const [loading, setLoading] = useState(false);
  const { MARKET_PLACE } = PROTECTED_PATHS;
  const [input, setInput] = useState("");
  const [advertProducts, setAdvertProducts] = useState([]);
  const navigate = useNavigate();
  const { TOP_PRODUCT_SCREEN } = PROTECTED_PATHS;
  const parentPath = dynamicPathhandler(TOP_PRODUCT_SCREEN);
  useEffect(() => {
    getAdvertProducts(userId, setLoading, setAdvertProducts);
  }, [userId]);
  console.log("advertProducts", advertProducts);

  return loading ? (
    <FullPageLoader />
  ) : (
    <Stack>
      <Box shadow="sm">
        <Container>
          <Header goto={MARKET_PLACE} />
        </Container>
      </Box>

      <Container>
        <Box py="5" mb="50px">
          <SearchBar input={input} setInput={setInput} />
        </Box>
        {advertProducts?.length > 0 ? (
          <Grid templateColumns="repeat(3, 1fr)" gap={4}>
            {advertProducts?.map((products, index) => (
              <>
                <VStack
                  bg="#fff"
                  shadow="md"
                  rounded="lg"
                  p={"5px"}
                  cursor="pointer"
                  w="100%"
                  justify="center"
                  className="category-container"
                  key={index}
                  onClick={() => navigate(`${parentPath}/${products?._id}`)}
                >
                  <Img
                    w={["80px"]}
                    maxW="80px"
                    h={["70px"]}
                    objectFit="cover"
                    rounded="lg"
                    src={products?.imageUrl[0]}
                    alt={products?.itemName}
                  />

                  <Text
                    textAlign="center"
                    fontSize="12px"
                    fontWeight="600"
                    // color="#7A7A7A"
                    color={COLORS.green}
                  >
                    {products?.itemName}
                  </Text>
                </VStack>
              </>
            ))}
          </Grid>
        ) : (
          <Center flexDirection="column" h="70vh" w="100%">
            <Img src="/empty.svg" alt="empty" />
            <Text
              py="5"
              fontWeight="500"
              textAlign="center"
              color={appTextColor}
            >
              No top products yet
            </Text>
          </Center>
        )}
      </Container>
    </Stack>
  );
};

export default AllTopProduct;
